import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment'
import { Observable, map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  // httpUrl: any;
  // apiHost = environment.apiUrl || "https://localhost"
  // uiHost = environment.apiUrl || "https://localhost"
  // apiProtocol: any;
  // apiPort: any;
  erpUser: any
  private httpUrl = environment.apiUrl;
  constructor(private http: HttpClient) {

  }
  // this.uiHost = window.location.hostname;

  // if (this.uiHost === "localhost") {
  //   this.apiProtocol = "http";
  // } else {
  //   this.apiProtocol = "https";
  // }

  // console.log(this.uiHost,this.uiHost.startsWith("dev.awasbandhu.upda.co.in"))
  // if (this.uiHost.startsWith("dev.awasbandhu.upda.co.in")) {
  //   this.uiHost = 'dev.awasbandhu.upda.co.in';
  //   this.apiPort = '3011';

  // } else if (this.uiHost.startsWith("uat.dev.awasbandhu.upda.co.in")) {
  //   this.uiHost = 'uat.dev.awasbandhu.upda.co.in';
  //   this.apiPort = '3011';
  // } else {
  //   this.uiHost = 'localhost';
  //   this.apiPort = '3000';
  // }
  // this.httpUrl = this.apiProtocol + '://' + this.uiHost + ":" + this.apiPort;
  // }

  async sendCpatTokenToBackend(token: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/cm_dash/integration/cpatToken', token).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}

// private getApiUrl(): string {
//   const host = window.location.hostname;

//   if (host === 'localhost') {
//     return 'http://localhost:3000';
//   }
//   else if (host.startsWith('uat.dev.awasbandhu.upda.co.in')) {
//     return 'https://uat.dev.awasbandhu.upda.co.in:3011';
//   } else {
//     return environment.apiUrl || 'http://localhost:3000';
//   }
// }



